<template>
  <div class="wrapper">
<HeaderVue></HeaderVue>
<transition name="page" mode="out-in">
  <router-view></router-view>
</transition>
<FooterVue></FooterVue>
  </div>

</template>

<script>
import HeaderVue from './HeaderVue.vue';

import FooterVue from './FooterVue.vue';
export default {
  components:{
    HeaderVue,
 
    FooterVue
}
}
</script>

<style scoped>
  .page-enter{
    animation: bounce-in 0.8s;
  }
.page-enter-active {
    animation: bounce-in 0.8s;
}

.page-leave-active {
    animation: bounce-out 0.5s;
}
.page-move{
  animation: bounce-out 0.5s;
}

@keyframes bounce-in {
    0% {
        transform: scale(0.9);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

@keyframes bounce-out {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    100% {
        transform: scale(0.9);
        opacity: 0;
    }
}

</style>